import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../constants';
import { SpecialInstruction } from '../model';
import { ApplicationStateService } from './application-state.service';

@Injectable({
  providedIn: 'root',
})
export class SpecialInstructionService {
  constructor(
    private http: HttpClient,
    private applicationStateService: ApplicationStateService,
    @Inject(API_URL) private apiUrl: string
  ) {
  }

  getSpecialInstruction(authorizationByProductId: string): Observable<SpecialInstruction> {
    return this.http.get<SpecialInstruction>(this.getUrl(authorizationByProductId));
  }

  createUpdateSpecialInstruction(
    authorizationByProductId: string,
    specialInstructionNote: string,
    authorizationSpecialInstructionId?: string
  ): Observable<SpecialInstruction> {
    return this.http.put<SpecialInstruction>(this.getUrl(authorizationByProductId), {
      specialInstructionNote,
      authorizationSpecialInstructionId,
    });
  }

  private getUrl(authId: string): string {
    return `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}/authorizations/${authId}/SpecialInstruction`;
  }
}
